import React, { useState } from "react";
import { ProductDraftCropImage } from "src/components/upload/ProductDraftCropImage";
import { getResizer } from "src/lib/ResizerImage";

export function Origin({ state, onFrontImage }: { state: any; onFrontImage: any }) {
  let refUpload: HTMLInputElement;
  const [file, setFile] = useState<any>(null);
  const [image, setImage] = useState<any>(state.frontStoreImage);

  const onChangeUpload = (e: any) => {
    getResizer(e.target.files[0]).then((res: any) => {
      const blob = URL.createObjectURL(res);
      setFile({
        src: blob,
        iscrop: false,
      });
    });
  };

  return (
    <div className="up-controls">
      <div className="row">
        <div className="col-sm-6">
          <div className="value-pair">
            <div className="value badge badge-pill">
              <img
                src={
                  state.origin
                    ? `/assets/${state.origin === "Local" ? "cambodia" : state.origin!.toLowerCase()}.svg`
                    : `/assets/blank.png`
                }
                alt=""
                style={{ marginRight: 5, width: 50 }}
              />
              {state.origin}
            </div>
          </div>
        </div>
        <div className="col-sm-6 text-right">
          <input
            type="file"
            value=""
            ref={(ref) => (refUpload = ref!)}
            onChange={onChangeUpload}
            style={{ display: "none" }}
          />
          {!!file && (
            <ProductDraftCropImage
              value={file}
              onSuccess={async (v) => {
                setImage(v.src);
                setFile(null);
                onFrontImage(v.src);
              }}
              onClose={() => setFile(null)}
              only="square"
            />
          )}
        </div>
        <div className="col-sm-12">
          <hr />
        </div>
        <div className="col-sm-6">
          <div className="value-pair">
            <div className="value badge badge-pill">
              <img
                src={image}
                alt=""
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  borderRadius: 4,
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-sm-6 text-right"
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          <button className="btn btn-outline-primary btn-sm" type="button" onClick={() => refUpload.click()}>
            Upload front store
          </button>
        </div>
      </div>
    </div>
  );
}
